import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { clientConstants, clientModels } from '..';

export const useForceAttachClientConfigAll = () =>
  useQuery<clientModels.IForceAttachClientConfigAll[]>({
    queryKey: [clientConstants.queryKeys.FORCE_ATTACH_CLIENT_CONFIG_ALL],
    queryFn: async () => {
      const res = await $api.get('/v1/force-attach-client/config/all');

      return res?.data?.data;
    }
  });
